import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowRightIcon, FileTextIcon } from 'lucide-react';
import { PageHero } from '../components/layout/PageHero';
import { CtaBand } from '../components/ui/CtaBand';
import { NotFound } from './NotFound';
import { facts, getFact } from '../data/faqs';
import { policies } from '../data/policies';
export function FactDetail() {
  const {
    slug = ''
  } = useParams();
  const fact = getFact(slug);
  if (!fact) {
    return <NotFound data-id="element-849" data-mp="ej2zbh5m6df0" />;
  }
  const others = facts.filter(item => item.slug !== fact.slug).slice(0, 3);
  return <>
      <PageHero eyebrow={`Facts & answers · ${fact.topic}`} title={fact.claim} crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Facts & Answers',
      to: '/facts'
    }, {
      label: fact.topic
    }]} meta={<p className="text-[14px] text-white/60" data-id="element-851" data-mp="3rzk6ggk9i3pr">Last updated {fact.updated}</p>} data-id="element-850" data-mp="nlucpmi1vj9a" />

      <section className="bg-sand-50 py-14 lg:py-20" aria-label="Clarification" data-id="element-852" data-mp="3vzunqpdi8gjx">
        <div className="mx-auto grid max-w-content gap-10 px-4 sm:px-6 lg:grid-cols-12 lg:px-10" data-id="element-853" data-mp="33g2xje546cv0">
          <div className="lg:col-span-8" data-id="element-854" data-mp="2yj2rv4c6fc4f">
            <div className="rounded-media border border-green-200 bg-white p-7 lg:p-9" data-id="element-855" data-mp="2ykdtoym2a9sw">
              <p className="text-[12px] font-bold uppercase tracking-[0.12em] text-green-700" data-id="element-856" data-mp="2tp89q5c7z57g">
                Official position
              </p>
              <p className="mt-3 font-display text-[26px] leading-snug text-ink" data-id="element-857" data-mp="2jtn4zzfrnqu0">
                {fact.position}
              </p>
              <p className="mt-5 text-[17px] leading-relaxed text-slate-700" data-id="element-858" data-mp="2fpyup8zr2h52">{fact.explanation}</p>
            </div>

            <h2 className="mt-10 text-[12px] font-bold uppercase tracking-[0.12em] text-slate-500" data-id="element-859" data-mp="2aujielhe4tar">
              Evidence and sources
            </h2>
            <ul className="mt-4 divide-y divide-sand-300 border-y border-sand-300" data-id="element-860" data-mp="91c4nghfejqz">
              {fact.sources.map(source => <li key={source} className="flex items-start gap-3 py-4" data-id="element-861" data-mp="42ipljmhqkop">
                  <FileTextIcon aria-hidden className="mt-0.5 h-4 w-4 shrink-0 text-green-600" data-id="element-862" data-mp="1yh6cl2x8w4yv" />
                  <span className="text-[16px] text-slate-700" data-id="element-863" data-mp="239zhbqsprday">{source}</span>
                </li>)}
            </ul>
            <Link to="/media" className="mt-5 inline-flex items-center gap-2 text-[15px] font-semibold text-green-700" data-id="element-864" data-mp="1oluxgjhxcvql">
              Download the supporting documents
              <ArrowRightIcon aria-hidden className="h-4 w-4" data-id="element-865" data-mp="2h6me9tko23gv" />
            </Link>
          </div>

          <aside className="lg:col-span-4" data-id="element-866" data-mp="2m5pkhhcdufqf">
            <div className="rounded-media border border-sand-200 bg-white p-6" data-id="element-867" data-mp="27b19xos4kr3y">
              <h2 className="font-display text-[20px] text-ink" data-id="element-868" data-mp="2c9cgnqn4ilhy">Related policies</h2>
              <ul className="mt-4 space-y-2" data-id="element-869" data-mp="2cbfhl5ptdz1g">
                {policies.slice(0, 3).map(policy => <li key={policy.slug} data-id="element-870" data-mp="10ufpaa3gvk7f">
                    <Link to={`/agenda/${policy.slug}`} className="group flex items-center justify-between rounded-lg border border-sand-200 px-4 py-3 transition-colors duration-200 ease-emphasis hover:border-green-200 hover:bg-sand-50" data-id="element-871" data-mp="10vidubdbhak6">
                      <span className="text-[15px] text-ink" data-id="element-872" data-mp="3o1ljtvw4h3g8">{policy.title}</span>
                      <ArrowRightIcon aria-hidden className="h-4 w-4 text-green-600 transition-transform duration-200 ease-emphasis group-hover:translate-x-1" data-id="element-873" data-mp="3k11mar7mzxtk" />
                    </Link>
                  </li>)}
              </ul>

              <h2 className="mt-8 font-display text-[20px] text-ink" data-id="element-874" data-mp="354u4fxjpb8hg">Other clarifications</h2>
              <ul className="mt-4 space-y-3" data-id="element-875" data-mp="30c9c70gg13g1">
                {others.map(item => <li key={item.slug} data-id="element-876" data-mp="2cmy756s28mw3">
                    <Link to={`/facts/${item.slug}`} className="block text-[14px] leading-relaxed text-slate-600 transition-colors duration-150 ease-emphasis hover:text-green-700" data-id="element-877" data-mp="2clwyta2fiei2">
                      {item.claim}
                    </Link>
                  </li>)}
              </ul>
            </div>
          </aside>
        </div>
      </section>

      <CtaBand title="Help stop misinformation in your ward." description="Digital volunteers receive verified responses within hours of a claim circulating." primary={{
      label: 'Join the digital campaign',
      to: '/join'
    }} secondary={{
      label: 'All clarifications',
      to: '/facts'
    }} data-id="element-878" data-mp="3009sibbmuyzj" />
    </>;
}